module.exports = __webpack_public_path__ + "static/media/PSD_07.ee721ccc.png";